import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { firebaseConfig } from './config'
import { IS_DEV_ENV } from '@/core/constants'

const firebaseApp = initializeApp(firebaseConfig)
const auth = getAuth(firebaseApp)

if (IS_DEV_ENV) {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
}

export { firebaseApp, auth }
